import { useQuery } from '@apollo/client';
import { GET_ENHANCED_RACE_RESULTS } from '../../graphql/queries/getEnhancedResults';
import { useViewer } from '../shell';
import type { RaceResults } from './lib';

/**
 * A meeting's results (public), joined to the picks of the viewer's model.
 * `date` is YYYYMMDD; `trackCode` is the track's code. Passes analysisTypeId so
 * the Top 1 / Value tags match the tips on screen (the app hook left it at 1).
 */
export function useRaceResults(date: string | undefined, trackCode: string | undefined) {
  const { analysisTypeId } = useViewer();
  return useQuery<{ getEnhancedRaceResults: RaceResults[] }>(GET_ENHANCED_RACE_RESULTS, {
    variables: {
      date: date ? `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}` : null,
      trackName: trackCode?.toLowerCase(),
      analysisTypeId,
    },
    skip: !date || !trackCode,
    fetchPolicy: 'cache-and-network',
  });
}
